import { Menu, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useCallback, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { PRODUCT_NAME_TOOLKIT } from "@helpers/constants";
import { logout } from "@helpers/utils";

import { ServiceNowOLogo } from "../../../icons";
import Avatar from "./Avatar";

export const headerClassName = "eai_header_nav_bar";

const HeaderRoot = styled("header")(({ theme }) => ({
  background: theme.palette.text.primary,
  padding: "0px 2rem",
  display: "grid",
  gridAutoFlow: "column",
  gridTemplateColumns: "auto 1fr auto auto",
  justifyContent: "start",
  alignItems: "center",
  gap: "1rem",
  height: "64px",
}));

const Logo = styled(Link)(() => ({
  fontSize: 0,
  "& svg": { width: "1.8rem", height: "1.8rem" },
}));

const TitleLink = styled(Link)(() => ({
  color: "white",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "24px",
  textDecoration: "none",
}));

const menuAnchorOrigin = { vertical: "bottom", horizontal: "right" } as const;

const menuTransformOrigin = { vertical: "top", horizontal: "right" } as const;

const Header = () => {
  const userIconRef = useRef<HTMLDivElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuOpen = useCallback(() => {
    setMenuOpen(true);
  }, []);

  const handleMenuClose = useCallback(() => {
    setMenuOpen(false);
  }, []);

  return (
    <HeaderRoot className={headerClassName}>
      <Logo to="/">
        <ServiceNowOLogo />
      </Logo>
      <TitleLink to="/">{PRODUCT_NAME_TOOLKIT}</TitleLink>
      <Avatar ref={userIconRef} onClick={handleMenuOpen} showTooltip />
      <Menu
        open={menuOpen}
        MenuListProps={{ onClick: handleMenuClose }}
        onClose={handleMenuClose}
        anchorEl={userIconRef.current}
        // we need to set this to null for the Menu to take our anchorEl.
        // https://github.com/mui-org/material-ui/issues/12208#issuecomment-406820537
        anchorOrigin={menuAnchorOrigin}
        transformOrigin={menuTransformOrigin}
      >
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </HeaderRoot>
  );
};

export default Header;
